import { appPath } from '@fs/zion-config'
import debug from '@fs/zion-debug'
import { useAppProvider } from '../providers/AppProvider'
import { isEmpty } from '../utils/is'
import useIsInmate from './useIsInmate'

// https://integration.familysearch.org/auth/familysearch/login?display=lite&returnUrl=https%3A%2F%2Fintegration.familysearch.org%2Fidentity%2Fsettings%2Fprofile
// https://familysearch.slack.com/archives/C06FR9QDBRB/p1729522599563219

const log = debug('give:useLogin')

const useLogin = () => {
  const { isInmate } = useIsInmate()
  const { accessFromPrison } = useAppProvider()

  const login = ({ returnUrlContent } = {}) => {
    if (isEmpty(returnUrlContent)) {
      const url =
        isInmate || accessFromPrison
          ? `/auth/familysearch/login?display=lite&returnUrl=${encodeURIComponent(window.location.href)}`
          : `/auth/familysearch/login?returnUrl=${encodeURIComponent(window.location.href)}`
      log('login url', url)
      window.location.href = url
    } else {
      const url =
        isInmate || accessFromPrison
          ? `/auth/familysearch/login?display=lite&returnUrl=${encodeURIComponent(`${appPath}/${returnUrlContent}`)}`
          : `/auth/familysearch/login?returnUrl=${encodeURIComponent(`${appPath}/${returnUrlContent}`)}`
      log('login url', url)
      window.location.href = url
    }
  }
  return { login }
}
export default useLogin
